import * as Yup from 'yup';
export const VendorInviteValidations = Yup.object().shape({
  // recommendedVendorMNDA: Yup.bool().oneOf([true], 'Vendor must use HSBC Bank MNDA  is required')
});